import { jsx as li } from "react/jsx-runtime";
import { createContext as ti, useSyncExternalStore as fn, useContext as ci } from "react";
const jn = "https://console.nimbalyst.com", sn = "app", ui = ["prompt", "answer", "comment"], fi = ["prompt", "answer"], si = ["claude-code"];
function V(r) {
  return encodeURIComponent(r).replace(/[()'*!~]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`);
}
function $(r) {
  try {
    const t = decodeURIComponent(r);
    return t === "" ? null : t;
  } catch {
    return null;
  }
}
function pn(r) {
  return r === "local" ? `/${sn}` : `/org/${V(r.orgId)}/project/${V(r.projectId)}`;
}
function ai(r) {
  return r.kind === "type" ? `/view/type/${V(r.typeId)}` : r.marks === "all" ? "/view/marks" : `/view/marks?kind=${r.marks}`;
}
function pi(r) {
  if (r.kind === "citation") {
    const k = [...r.agent ? [r.agent] : [], r.sessionId, r.inputKind, r.key];
    return `/${sn}/cite/${k.map(V).join("/")}`;
  }
  if (r.kind === "commentCitation")
    return `${pn(r.scope)}/document/${V(r.pageId)}?comment=${V(r.commentId)}`;
  const t = pn(r.scope), m = r.scope === "local";
  switch (r.kind) {
    case "page":
      return `${t}/${m ? "page" : "document"}/${V(r.pageId)}`;
    case "item":
      return `${t}/${m ? "item" : "page/item"}/${V(r.itemRef)}`;
    case "type":
      return `${t}/${m ? "type" : "page/type"}/${V(r.typeId)}`;
    case "view":
      return `${t}${ai(r.view)}`;
  }
}
function Mi(r, t = jn) {
  return `${t}${pi(r)}`;
}
function di(r, t) {
  const m = r.split("/").slice(1);
  if (m.some((l) => l === "")) return null;
  let k, p;
  if (m[0] === sn)
    k = "local", p = m.slice(1);
  else if (m[0] === "org" && m[2] === "project" && m.length > 4) {
    const l = $(m[1]), T = $(m[3]);
    if (!l || !T) return null;
    k = { orgId: l, projectId: T }, p = m.slice(4);
  } else
    return null;
  const S = k === "local", [h, s, b, c] = p;
  if (p[0] === "view") {
    if (p.length === 3 && s === "type") {
      const l = $(b);
      return l ? { kind: "view", scope: k, view: { kind: "type", typeId: l } } : null;
    }
    if (p.length === 2 && s === "marks") {
      const l = t.get("kind");
      return l === null ? { kind: "view", scope: k, view: { kind: "marks", marks: "all" } } : l === "decided" || l === "open" ? { kind: "view", scope: k, view: { kind: "marks", marks: l } } : null;
    }
    return null;
  }
  if (S) {
    if (h === "cite" && p.length === 4) {
      const T = $(s), x = $(c), N = b;
      return !T || !x || !ui.includes(N) ? null : { kind: "citation", sessionId: T, inputKind: N, key: x };
    }
    if (h === "cite" && p.length === 5) {
      const T = s, x = $(b), N = c, U = $(p[4]);
      return !si.includes(T) || !x || !U || !fi.includes(N) ? null : { kind: "citation", agent: T, sessionId: x, inputKind: N, key: U };
    }
    if (p.length !== 2) return null;
    const l = $(s);
    return l ? h === "page" ? { kind: "page", scope: k, pageId: l } : h === "item" ? { kind: "item", scope: k, itemRef: l } : h === "type" ? { kind: "type", scope: k, typeId: l } : null : null;
  }
  if (h === "document" && p.length === 2) {
    const l = $(s);
    if (!l) return null;
    const T = t.get("comment");
    return T === null ? { kind: "page", scope: k, pageId: l } : T && k !== "local" ? { kind: "commentCitation", scope: k, pageId: l, commentId: T } : null;
  }
  if ((h === "page" || h === "trackers") && p.length === 3) {
    const l = $(b);
    if (!l) return null;
    if (s === "item") return { kind: "item", scope: k, itemRef: l };
    if (s === "type") return { kind: "type", scope: k, typeId: l };
  }
  return null;
}
function Fi(r, t = {}) {
  if (!r) return null;
  let m;
  try {
    m = new URL(r);
  } catch {
    return null;
  }
  return [jn, ...t.origins ?? []].includes(m.origin) ? di(m.pathname, m.searchParams) : null;
}
function hi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var P = {}, Oe = {}, ee = {}, dn;
function ge() {
  if (dn) return ee;
  dn = 1;
  function r(h) {
    return typeof h > "u" || h === null;
  }
  function t(h) {
    return typeof h == "object" && h !== null;
  }
  function m(h) {
    return Array.isArray(h) ? h : r(h) ? [] : [h];
  }
  function k(h, s) {
    if (s) {
      const b = Object.keys(s);
      for (let c = 0, l = b.length; c < l; c += 1) {
        const T = b[c];
        h[T] = s[T];
      }
    }
    return h;
  }
  function p(h, s) {
    let b = "";
    for (let c = 0; c < s; c += 1)
      b += h;
    return b;
  }
  function S(h) {
    return h === 0 && Number.NEGATIVE_INFINITY === 1 / h;
  }
  return ee.isNothing = r, ee.isObject = t, ee.toArray = m, ee.repeat = p, ee.isNegativeZero = S, ee.extend = k, ee;
}
var je, hn;
function ye() {
  if (hn) return je;
  hn = 1;
  function r(m, k) {
    let p = "";
    const S = m.reason || "(unknown reason)";
    return m.mark ? (m.mark.name && (p += 'in "' + m.mark.name + '" '), p += "(" + (m.mark.line + 1) + ":" + (m.mark.column + 1) + ")", !k && m.mark.snippet && (p += `

` + m.mark.snippet), S + " " + p) : S;
  }
  function t(m, k) {
    Error.call(this), this.name = "YAMLException", this.reason = m, this.mark = k, this.message = r(this, !1), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
  }
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t.prototype.toString = function(k) {
    return this.name + ": " + r(this, k);
  }, je = t, je;
}
var Be, mn;
function mi() {
  if (mn) return Be;
  mn = 1;
  const r = ge();
  function t(p, S, h, s, b) {
    let c = "", l = "";
    const T = Math.floor(b / 2) - 1;
    return s - S > T && (c = " ... ", S = s - T + c.length), h - s > T && (l = " ...", h = s + T - l.length), {
      str: c + p.slice(S, h).replace(/\t/g, "→") + l,
      pos: s - S + c.length
      // relative position
    };
  }
  function m(p, S) {
    return r.repeat(" ", S - p.length) + p;
  }
  function k(p, S) {
    if (S = Object.create(S || null), !p.buffer) return null;
    S.maxLength || (S.maxLength = 79), typeof S.indent != "number" && (S.indent = 1), typeof S.linesBefore != "number" && (S.linesBefore = 3), typeof S.linesAfter != "number" && (S.linesAfter = 2);
    const h = /\r?\n|\r|\0/g, s = [0], b = [];
    let c, l = -1;
    for (; c = h.exec(p.buffer); )
      b.push(c.index), s.push(c.index + c[0].length), p.position <= c.index && l < 0 && (l = s.length - 2);
    l < 0 && (l = s.length - 1);
    let T = "";
    const x = Math.min(p.line + S.linesAfter, b.length).toString().length, N = S.maxLength - (S.indent + x + 3);
    for (let R = 1; R <= S.linesBefore && !(l - R < 0); R++) {
      const H = t(
        p.buffer,
        s[l - R],
        b[l - R],
        p.position - (s[l] - s[l - R]),
        N
      );
      T = r.repeat(" ", S.indent) + m((p.line - R + 1).toString(), x) + " | " + H.str + `
` + T;
    }
    const U = t(p.buffer, s[l], b[l], p.position, N);
    T += r.repeat(" ", S.indent) + m((p.line + 1).toString(), x) + " | " + U.str + `
`, T += r.repeat("-", S.indent + x + 3 + U.pos) + `^
`;
    for (let R = 1; R <= S.linesAfter && !(l + R >= b.length); R++) {
      const H = t(
        p.buffer,
        s[l + R],
        b[l + R],
        p.position - (s[l] - s[l + R]),
        N
      );
      T += r.repeat(" ", S.indent) + m((p.line + R + 1).toString(), x) + " | " + H.str + `
`;
    }
    return T.replace(/\n$/, "");
  }
  return Be = k, Be;
}
var He, gn;
function D() {
  if (gn) return He;
  gn = 1;
  const r = ye(), t = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
  ], m = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function k(S) {
    const h = {};
    return S !== null && Object.keys(S).forEach(function(s) {
      S[s].forEach(function(b) {
        h[String(b)] = s;
      });
    }), h;
  }
  function p(S, h) {
    if (h = h || {}, Object.keys(h).forEach(function(s) {
      if (t.indexOf(s) === -1)
        throw new r('Unknown option "' + s + '" is met in definition of "' + S + '" YAML type.');
    }), this.options = h, this.tag = S, this.kind = h.kind || null, this.resolve = h.resolve || function() {
      return !0;
    }, this.construct = h.construct || function(s) {
      return s;
    }, this.instanceOf = h.instanceOf || null, this.predicate = h.predicate || null, this.represent = h.represent || null, this.representName = h.representName || null, this.defaultStyle = h.defaultStyle || null, this.multi = h.multi || !1, this.styleAliases = k(h.styleAliases || null), m.indexOf(this.kind) === -1)
      throw new r('Unknown kind "' + this.kind + '" is specified for "' + S + '" YAML type.');
  }
  return He = p, He;
}
var Ue, yn;
function Bn() {
  if (yn) return Ue;
  yn = 1;
  const r = ye(), t = D();
  function m(S, h) {
    const s = [];
    return S[h].forEach(function(b) {
      let c = s.length;
      s.forEach(function(l, T) {
        l.tag === b.tag && l.kind === b.kind && l.multi === b.multi && (c = T);
      }), s[c] = b;
    }), s;
  }
  function k() {
    const S = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {},
      multi: {
        scalar: [],
        sequence: [],
        mapping: [],
        fallback: []
      }
    };
    function h(s) {
      s.multi ? (S.multi[s.kind].push(s), S.multi.fallback.push(s)) : S[s.kind][s.tag] = S.fallback[s.tag] = s;
    }
    for (let s = 0, b = arguments.length; s < b; s += 1)
      arguments[s].forEach(h);
    return S;
  }
  function p(S) {
    return this.extend(S);
  }
  return p.prototype.extend = function(h) {
    let s = [], b = [];
    if (h instanceof t)
      b.push(h);
    else if (Array.isArray(h))
      b = b.concat(h);
    else if (h && (Array.isArray(h.implicit) || Array.isArray(h.explicit)))
      h.implicit && (s = s.concat(h.implicit)), h.explicit && (b = b.concat(h.explicit));
    else
      throw new r("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    s.forEach(function(l) {
      if (!(l instanceof t))
        throw new r("Specified list of YAML types (or a single Type object) contains a non-Type object.");
      if (l.loadKind && l.loadKind !== "scalar")
        throw new r("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      if (l.multi)
        throw new r("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    }), b.forEach(function(l) {
      if (!(l instanceof t))
        throw new r("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    const c = Object.create(p.prototype);
    return c.implicit = (this.implicit || []).concat(s), c.explicit = (this.explicit || []).concat(b), c.compiledImplicit = m(c, "implicit"), c.compiledExplicit = m(c, "explicit"), c.compiledTypeMap = k(c.compiledImplicit, c.compiledExplicit), c;
  }, Ue = p, Ue;
}
var Ke, An;
function Hn() {
  if (An) return Ke;
  An = 1;
  const r = D();
  return Ke = new r("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(t) {
      return t !== null ? t : "";
    }
  }), Ke;
}
var $e, Sn;
function Un() {
  if (Sn) return $e;
  Sn = 1;
  const r = D();
  return $e = new r("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(t) {
      return t !== null ? t : [];
    }
  }), $e;
}
var We, wn;
function Kn() {
  if (wn) return We;
  wn = 1;
  const r = D();
  return We = new r("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(t) {
      return t !== null ? t : {};
    }
  }), We;
}
var Ge, bn;
function $n() {
  if (bn) return Ge;
  bn = 1;
  const r = Bn();
  return Ge = new r({
    explicit: [
      Hn(),
      Un(),
      Kn()
    ]
  }), Ge;
}
var Ve, Tn;
function Wn() {
  if (Tn) return Ve;
  Tn = 1;
  const r = D();
  function t(p) {
    if (p === null) return !0;
    const S = p.length;
    return S === 1 && p === "~" || S === 4 && (p === "null" || p === "Null" || p === "NULL");
  }
  function m() {
    return null;
  }
  function k(p) {
    return p === null;
  }
  return Ve = new r("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: t,
    construct: m,
    predicate: k,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      },
      empty: function() {
        return "";
      }
    },
    defaultStyle: "lowercase"
  }), Ve;
}
var Qe, Cn;
function Gn() {
  if (Cn) return Qe;
  Cn = 1;
  const r = D();
  function t(p) {
    if (p === null) return !1;
    const S = p.length;
    return S === 4 && (p === "true" || p === "True" || p === "TRUE") || S === 5 && (p === "false" || p === "False" || p === "FALSE");
  }
  function m(p) {
    return p === "true" || p === "True" || p === "TRUE";
  }
  function k(p) {
    return Object.prototype.toString.call(p) === "[object Boolean]";
  }
  return Qe = new r("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: t,
    construct: m,
    predicate: k,
    represent: {
      lowercase: function(p) {
        return p ? "true" : "false";
      },
      uppercase: function(p) {
        return p ? "TRUE" : "FALSE";
      },
      camelcase: function(p) {
        return p ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), Qe;
}
var Je, kn;
function Vn() {
  if (kn) return Je;
  kn = 1;
  const r = ge(), t = D();
  function m(c) {
    return c >= 48 && c <= 57 || c >= 65 && c <= 70 || c >= 97 && c <= 102;
  }
  function k(c) {
    return c >= 48 && c <= 55;
  }
  function p(c) {
    return c >= 48 && c <= 57;
  }
  function S(c) {
    if (c === null) return !1;
    const l = c.length;
    let T = 0, x = !1;
    if (!l) return !1;
    let N = c[T];
    if ((N === "-" || N === "+") && (N = c[++T]), N === "0") {
      if (T + 1 === l) return !0;
      if (N = c[++T], N === "b") {
        for (T++; T < l; T++) {
          if (N = c[T], N !== "0" && N !== "1") return !1;
          x = !0;
        }
        return x && isFinite(h(c));
      }
      if (N === "x") {
        for (T++; T < l; T++) {
          if (!m(c.charCodeAt(T))) return !1;
          x = !0;
        }
        return x && isFinite(h(c));
      }
      if (N === "o") {
        for (T++; T < l; T++) {
          if (!k(c.charCodeAt(T))) return !1;
          x = !0;
        }
        return x && isFinite(h(c));
      }
    }
    for (; T < l; T++) {
      if (!p(c.charCodeAt(T)))
        return !1;
      x = !0;
    }
    return x ? isFinite(h(c)) : !1;
  }
  function h(c) {
    let l = c, T = 1, x = l[0];
    if ((x === "-" || x === "+") && (x === "-" && (T = -1), l = l.slice(1), x = l[0]), l === "0") return 0;
    if (x === "0") {
      if (l[1] === "b") return T * parseInt(l.slice(2), 2);
      if (l[1] === "x") return T * parseInt(l.slice(2), 16);
      if (l[1] === "o") return T * parseInt(l.slice(2), 8);
    }
    return T * parseInt(l, 10);
  }
  function s(c) {
    return h(c);
  }
  function b(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && c % 1 === 0 && !r.isNegativeZero(c);
  }
  return Je = new t("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: S,
    construct: s,
    predicate: b,
    represent: {
      binary: function(c) {
        return c >= 0 ? "0b" + c.toString(2) : "-0b" + c.toString(2).slice(1);
      },
      octal: function(c) {
        return c >= 0 ? "0o" + c.toString(8) : "-0o" + c.toString(8).slice(1);
      },
      decimal: function(c) {
        return c.toString(10);
      },
      hexadecimal: function(c) {
        return c >= 0 ? "0x" + c.toString(16).toUpperCase() : "-0x" + c.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), Je;
}
var Xe, En;
function Qn() {
  if (En) return Xe;
  En = 1;
  const r = ge(), t = D(), m = new RegExp(
    // 2.5e4, 2.5 and integers
    "^(?:[-+]?(?:[0-9]+)(?:\\.[0-9]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"
  ), k = new RegExp(
    "^(?:[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"
  );
  function p(c) {
    return c === null || !m.test(c) ? !1 : isFinite(parseFloat(c, 10)) ? !0 : k.test(c);
  }
  function S(c) {
    let l = c.toLowerCase();
    const T = l[0] === "-" ? -1 : 1;
    return "+-".indexOf(l[0]) >= 0 && (l = l.slice(1)), l === ".inf" ? T === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : l === ".nan" ? NaN : T * parseFloat(l, 10);
  }
  const h = /^[-+]?[0-9]+e/;
  function s(c, l) {
    if (isNaN(c))
      switch (l) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === c)
      switch (l) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === c)
      switch (l) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (r.isNegativeZero(c))
      return "-0.0";
    const T = c.toString(10);
    return h.test(T) ? T.replace("e", ".e") : T;
  }
  function b(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && (c % 1 !== 0 || r.isNegativeZero(c));
  }
  return Xe = new t("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: p,
    construct: S,
    predicate: b,
    represent: s,
    defaultStyle: "lowercase"
  }), Xe;
}
var Ze, _n;
function Jn() {
  return _n || (_n = 1, Ze = $n().extend({
    implicit: [
      Wn(),
      Gn(),
      Vn(),
      Qn()
    ]
  })), Ze;
}
var ze, In;
function Xn() {
  return In || (In = 1, ze = Jn()), ze;
}
var en, xn;
function Zn() {
  if (xn) return en;
  xn = 1;
  const r = D(), t = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"
  ), m = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"
  );
  function k(h) {
    return h === null ? !1 : t.exec(h) !== null || m.exec(h) !== null;
  }
  function p(h) {
    let s = 0, b = null, c = t.exec(h);
    if (c === null && (c = m.exec(h)), c === null) throw new Error("Date resolve error");
    const l = +c[1], T = +c[2] - 1, x = +c[3];
    if (!c[4])
      return new Date(Date.UTC(l, T, x));
    const N = +c[4], U = +c[5], R = +c[6];
    if (c[7]) {
      for (s = c[7].slice(0, 3); s.length < 3; )
        s += "0";
      s = +s;
    }
    if (c[9]) {
      const ne = +c[10], Y = +(c[11] || 0);
      b = (ne * 60 + Y) * 6e4, c[9] === "-" && (b = -b);
    }
    const H = new Date(Date.UTC(l, T, x, N, U, R, s));
    return b && H.setTime(H.getTime() - b), H;
  }
  function S(h) {
    return h.toISOString();
  }
  return en = new r("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: k,
    construct: p,
    instanceOf: Date,
    represent: S
  }), en;
}
var nn, vn;
function zn() {
  if (vn) return nn;
  vn = 1;
  const r = D();
  function t(m) {
    return m === "<<" || m === null;
  }
  return nn = new r("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: t
  }), nn;
}
var rn, On;
function ei() {
  if (On) return rn;
  On = 1;
  const r = D(), t = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function m(h) {
    if (h === null) return !1;
    let s = 0;
    const b = h.length, c = t;
    for (let l = 0; l < b; l++) {
      const T = c.indexOf(h.charAt(l));
      if (!(T > 64)) {
        if (T < 0) return !1;
        s += 6;
      }
    }
    return s % 8 === 0;
  }
  function k(h) {
    const s = h.replace(/[\r\n=]/g, ""), b = s.length, c = t;
    let l = 0;
    const T = [];
    for (let N = 0; N < b; N++)
      N % 4 === 0 && N && (T.push(l >> 16 & 255), T.push(l >> 8 & 255), T.push(l & 255)), l = l << 6 | c.indexOf(s.charAt(N));
    const x = b % 4 * 6;
    return x === 0 ? (T.push(l >> 16 & 255), T.push(l >> 8 & 255), T.push(l & 255)) : x === 18 ? (T.push(l >> 10 & 255), T.push(l >> 2 & 255)) : x === 12 && T.push(l >> 4 & 255), new Uint8Array(T);
  }
  function p(h) {
    let s = "", b = 0;
    const c = h.length, l = t;
    for (let x = 0; x < c; x++)
      x % 3 === 0 && x && (s += l[b >> 18 & 63], s += l[b >> 12 & 63], s += l[b >> 6 & 63], s += l[b & 63]), b = (b << 8) + h[x];
    const T = c % 3;
    return T === 0 ? (s += l[b >> 18 & 63], s += l[b >> 12 & 63], s += l[b >> 6 & 63], s += l[b & 63]) : T === 2 ? (s += l[b >> 10 & 63], s += l[b >> 4 & 63], s += l[b << 2 & 63], s += l[64]) : T === 1 && (s += l[b >> 2 & 63], s += l[b << 4 & 63], s += l[64], s += l[64]), s;
  }
  function S(h) {
    return Object.prototype.toString.call(h) === "[object Uint8Array]";
  }
  return rn = new r("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: m,
    construct: k,
    predicate: S,
    represent: p
  }), rn;
}
var on, Ln;
function ni() {
  if (Ln) return on;
  Ln = 1;
  const r = D(), t = Object.prototype.hasOwnProperty, m = Object.prototype.toString;
  function k(S) {
    if (S === null) return !0;
    const h = {}, s = S;
    for (let b = 0, c = s.length; b < c; b += 1) {
      const l = s[b];
      let T = !1;
      if (m.call(l) !== "[object Object]") return !1;
      let x;
      for (x in l)
        if (t.call(l, x))
          if (!T) T = !0;
          else return !1;
      if (!T || t.call(h, x)) return !1;
      Object.defineProperty(h, x, { value: !0 });
    }
    return !0;
  }
  function p(S) {
    return S !== null ? S : [];
  }
  return on = new r("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: k,
    construct: p
  }), on;
}
var ln, Nn;
function ii() {
  if (Nn) return ln;
  Nn = 1;
  const r = D(), t = Object.prototype.toString;
  function m(p) {
    if (p === null) return !0;
    const S = p, h = new Array(S.length);
    for (let s = 0, b = S.length; s < b; s += 1) {
      const c = S[s];
      if (t.call(c) !== "[object Object]") return !1;
      const l = Object.keys(c);
      if (l.length !== 1) return !1;
      h[s] = [l[0], c[l[0]]];
    }
    return !0;
  }
  function k(p) {
    if (p === null) return [];
    const S = p, h = new Array(S.length);
    for (let s = 0, b = S.length; s < b; s += 1) {
      const c = S[s], l = Object.keys(c);
      h[s] = [l[0], c[l[0]]];
    }
    return h;
  }
  return ln = new r("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: m,
    construct: k
  }), ln;
}
var tn, Rn;
function ri() {
  if (Rn) return tn;
  Rn = 1;
  const r = D(), t = Object.prototype.hasOwnProperty;
  function m(p) {
    if (p === null) return !0;
    const S = p;
    for (const h in S)
      if (t.call(S, h) && S[h] !== null)
        return !1;
    return !0;
  }
  function k(p) {
    return p !== null ? p : {};
  }
  return tn = new r("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: m,
    construct: k
  }), tn;
}
var cn, Mn;
function an() {
  return Mn || (Mn = 1, cn = Xn().extend({
    implicit: [
      Zn(),
      zn()
    ],
    explicit: [
      ei(),
      ni(),
      ii(),
      ri()
    ]
  })), cn;
}
var Fn;
function gi() {
  if (Fn) return Oe;
  Fn = 1;
  const r = ge(), t = ye(), m = mi(), k = an(), p = Object.prototype.hasOwnProperty, S = 1, h = 2, s = 3, b = 4, c = 1, l = 2, T = 3, x = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, N = /[\x85\u2028\u2029]/, U = /[,\[\]{}]/, R = /^(?:!|!!|![0-9A-Za-z-]+!)$/, H = /^(?:!|[^,\[\]{}])(?:%[0-9a-f]{2}|[0-9a-z\-#;/?:@&=+$,_.!~*'()\[\]])*$/i;
  function ne(e) {
    return Object.prototype.toString.call(e);
  }
  function Y(e) {
    return e === 10 || e === 13;
  }
  function j(e) {
    return e === 9 || e === 32;
  }
  function q(e) {
    return e === 9 || e === 32 || e === 10 || e === 13;
  }
  function Q(e) {
    return e === 44 || e === 91 || e === 93 || e === 123 || e === 125;
  }
  function Le(e) {
    if (e >= 48 && e <= 57)
      return e - 48;
    const i = e | 32;
    return i >= 97 && i <= 102 ? i - 97 + 10 : -1;
  }
  function Ne(e) {
    return e === 120 ? 2 : e === 117 ? 4 : e === 85 ? 8 : 0;
  }
  function Ae(e) {
    return e >= 48 && e <= 57 ? e - 48 : -1;
  }
  function te(e) {
    switch (e) {
      case 48:
        return "\0";
      case 97:
        return "\x07";
      case 98:
        return "\b";
      case 116:
        return "	";
      case 9:
        return "	";
      case 110:
        return `
`;
      case 118:
        return "\v";
      case 102:
        return "\f";
      case 114:
        return "\r";
      case 101:
        return "\x1B";
      case 32:
        return " ";
      case 34:
        return '"';
      case 47:
        return "/";
      case 92:
        return "\\";
      case 78:
        return "";
      case 95:
        return " ";
      case 76:
        return "\u2028";
      case 80:
        return "\u2029";
      default:
        return "";
    }
  }
  function Re(e) {
    return e <= 65535 ? String.fromCharCode(e) : String.fromCharCode(
      (e - 65536 >> 10) + 55296,
      (e - 65536 & 1023) + 56320
    );
  }
  function ce(e, i, d) {
    i === "__proto__" ? Object.defineProperty(e, i, {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: d
    }) : e[i] = d;
  }
  const Se = new Array(256), ue = new Array(256);
  for (let e = 0; e < 256; e++)
    Se[e] = te(e) ? 1 : 0, ue[e] = te(e);
  function F(e, i) {
    this.input = e, this.filename = i.filename || null, this.schema = i.schema || k, this.onWarning = i.onWarning || null, this.legacy = i.legacy || !1, this.json = i.json || !1, this.listener = i.listener || null, this.maxDepth = typeof i.maxDepth == "number" ? i.maxDepth : 100, this.maxTotalMergeKeys = typeof i.maxTotalMergeKeys == "number" ? i.maxTotalMergeKeys : 1e4, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = e.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.depth = 0, this.totalMergeKeys = 0, this.firstTabInLine = -1, this.documents = [], this.anchorMapTransactions = [];
  }
  function we(e, i) {
    const d = {
      name: e.filename,
      buffer: e.input.slice(0, -1),
      // omit trailing \0
      position: e.position,
      line: e.line,
      column: e.position - e.lineStart
    };
    return d.snippet = m(d), new t(i, d);
  }
  function _(e, i) {
    throw we(e, i);
  }
  function re(e, i) {
    e.onWarning && e.onWarning.call(null, we(e, i));
  }
  function W(e, i, d) {
    const g = e.anchorMapTransactions;
    if (g.length !== 0) {
      const f = g[g.length - 1];
      p.call(f, i) || (f[i] = {
        existed: p.call(e.anchorMap, i),
        value: e.anchorMap[i]
      });
    }
    e.anchorMap[i] = d;
  }
  function Me(e) {
    e.anchorMapTransactions.push(/* @__PURE__ */ Object.create(null));
  }
  function ie(e) {
    const i = e.anchorMapTransactions.pop(), d = e.anchorMapTransactions;
    if (d.length === 0) return;
    const g = d[d.length - 1], f = Object.keys(i);
    for (let n = 0, o = f.length; n < o; n += 1) {
      const u = f[n];
      p.call(g, u) || (g[u] = i[u]);
    }
  }
  function Fe(e) {
    const i = e.anchorMapTransactions.pop(), d = Object.keys(i);
    for (let g = d.length - 1; g >= 0; g -= 1) {
      const f = i[d[g]];
      f.existed ? e.anchorMap[d[g]] = f.value : delete e.anchorMap[d[g]];
    }
  }
  function fe(e) {
    return {
      position: e.position,
      line: e.line,
      lineStart: e.lineStart,
      lineIndent: e.lineIndent,
      firstTabInLine: e.firstTabInLine,
      tag: e.tag,
      anchor: e.anchor,
      kind: e.kind,
      result: e.result
    };
  }
  function oe(e, i) {
    e.position = i.position, e.line = i.line, e.lineStart = i.lineStart, e.lineIndent = i.lineIndent, e.firstTabInLine = i.firstTabInLine, e.tag = i.tag, e.anchor = i.anchor, e.kind = i.kind, e.result = i.result;
  }
  const be = {
    YAML: function(i, d, g) {
      i.version !== null && _(i, "duplication of %YAML directive"), g.length !== 1 && _(i, "YAML directive accepts exactly one argument");
      const f = /^([0-9]+)\.([0-9]+)$/.exec(g[0]);
      f === null && _(i, "ill-formed argument of the YAML directive");
      const n = parseInt(f[1], 10), o = parseInt(f[2], 10);
      n !== 1 && _(i, "unacceptable YAML version of the document"), i.version = g[0], i.checkLineBreaks = o < 2, o !== 1 && o !== 2 && re(i, "unsupported YAML version of the document");
    },
    TAG: function(i, d, g) {
      let f;
      g.length !== 2 && _(i, "TAG directive accepts exactly two arguments");
      const n = g[0];
      f = g[1], R.test(n) || _(i, "ill-formed tag handle (first argument) of the TAG directive"), p.call(i.tagMap, n) && _(i, 'there is a previously declared suffix for "' + n + '" tag handle'), H.test(f) || _(i, "ill-formed tag prefix (second argument) of the TAG directive");
      try {
        f = decodeURIComponent(f);
      } catch {
        _(i, "tag prefix is malformed: " + f);
      }
      i.tagMap[n] = f;
    }
  };
  function B(e, i, d, g) {
    if (i < d) {
      const f = e.input.slice(i, d);
      if (g)
        for (let n = 0, o = f.length; n < o; n += 1) {
          const u = f.charCodeAt(n);
          u === 9 || u >= 32 && u <= 1114111 || _(e, "expected valid JSON character");
        }
      else x.test(f) && _(e, "the stream contains non-printable characters");
      e.result += f;
    }
  }
  function J(e) {
    e.totalMergeKeys++, e.maxTotalMergeKeys !== -1 && e.totalMergeKeys > e.maxTotalMergeKeys && _(e, "merge keys exceeded maxTotalMergeKeys (" + e.maxTotalMergeKeys + ")");
  }
  function se(e, i, d, g) {
    r.isObject(d) || _(e, "cannot merge mappings; the provided source object is unacceptable"), J(e);
    const f = Object.keys(d);
    for (let n = 0, o = f.length; n < o; n += 1) {
      const u = f[n];
      J(e), p.call(i, u) || (ce(i, u, d[u]), g[u] = !0);
    }
  }
  function G(e, i, d, g, f, n, o, u, y) {
    if (Array.isArray(f)) {
      f = Array.prototype.slice.call(f);
      for (let A = 0, w = f.length; A < w; A += 1)
        Array.isArray(f[A]) && _(e, "nested arrays are not supported inside keys"), typeof f == "object" && ne(f[A]) === "[object Object]" && (f[A] = "[object Object]");
    }
    if (typeof f == "object" && ne(f) === "[object Object]" && (f = "[object Object]"), f = String(f), i === null && (i = {}), g === "tag:yaml.org,2002:merge")
      if (Array.isArray(n)) {
        n.length > 100 && _(e, "abnormal merge sequence size");
        for (let A = 0, w = n.length; A < w; A += 1)
          se(e, i, n[A], d);
      } else
        se(e, i, n, d);
    else
      !e.json && !p.call(d, f) && p.call(i, f) && (e.line = o || e.line, e.lineStart = u || e.lineStart, e.position = y || e.position, _(e, "duplicated mapping key")), ce(i, f, n), delete d[f];
    return i;
  }
  function ae(e) {
    const i = e.input.charCodeAt(e.position);
    i === 10 ? e.position++ : i === 13 ? (e.position++, e.input.charCodeAt(e.position) === 10 && e.position++) : _(e, "a line break is expected"), e.line += 1, e.lineStart = e.position, e.firstTabInLine = -1;
  }
  function M(e, i, d) {
    let g = 0, f = e.input.charCodeAt(e.position);
    for (; f !== 0; ) {
      for (; j(f); )
        f === 9 && e.firstTabInLine === -1 && (e.firstTabInLine = e.position), f = e.input.charCodeAt(++e.position);
      if (i && f === 35)
        do
          f = e.input.charCodeAt(++e.position);
        while (f !== 10 && f !== 13 && f !== 0);
      if (Y(f))
        for (ae(e), f = e.input.charCodeAt(e.position), g++, e.lineIndent = 0; f === 32; )
          e.lineIndent++, f = e.input.charCodeAt(++e.position);
      else
        break;
    }
    return d !== -1 && g !== 0 && e.lineIndent < d && re(e, "deficient indentation"), g;
  }
  function K(e) {
    let i = e.position, d = e.input.charCodeAt(i);
    return !!((d === 45 || d === 46) && d === e.input.charCodeAt(i + 1) && d === e.input.charCodeAt(i + 2) && (i += 3, d = e.input.charCodeAt(i), d === 0 || q(d)));
  }
  function le(e, i) {
    i === 1 ? e.result += " " : i > 1 && (e.result += r.repeat(`
`, i - 1));
  }
  function Te(e, i, d) {
    let g, f, n, o, u, y;
    const A = e.kind, w = e.result;
    let a = e.input.charCodeAt(e.position);
    if (q(a) || Q(a) || a === 35 || a === 38 || a === 42 || a === 33 || a === 124 || a === 62 || a === 39 || a === 34 || a === 37 || a === 64 || a === 96)
      return !1;
    if (a === 63 || a === 45) {
      const C = e.input.charCodeAt(e.position + 1);
      if (q(C) || d && Q(C))
        return !1;
    }
    for (e.kind = "scalar", e.result = "", g = f = e.position, n = !1; a !== 0; ) {
      if (a === 58) {
        const C = e.input.charCodeAt(e.position + 1);
        if (q(C) || d && Q(C))
          break;
      } else if (a === 35) {
        const C = e.input.charCodeAt(e.position - 1);
        if (q(C))
          break;
      } else {
        if (e.position === e.lineStart && K(e) || d && Q(a))
          break;
        if (Y(a))
          if (o = e.line, u = e.lineStart, y = e.lineIndent, M(e, !1, -1), e.lineIndent >= i) {
            n = !0, a = e.input.charCodeAt(e.position);
            continue;
          } else {
            e.position = f, e.line = o, e.lineStart = u, e.lineIndent = y;
            break;
          }
      }
      n && (B(e, g, f, !1), le(e, e.line - o), g = f = e.position, n = !1), j(a) || (f = e.position + 1), a = e.input.charCodeAt(++e.position);
    }
    return B(e, g, f, !1), e.result ? !0 : (e.kind = A, e.result = w, !1);
  }
  function pe(e, i) {
    let d, g, f = e.input.charCodeAt(e.position);
    if (f !== 39)
      return !1;
    for (e.kind = "scalar", e.result = "", e.position++, d = g = e.position; (f = e.input.charCodeAt(e.position)) !== 0; )
      if (f === 39)
        if (B(e, d, e.position, !0), f = e.input.charCodeAt(++e.position), f === 39)
          d = e.position, e.position++, g = e.position;
        else
          return !0;
      else Y(f) ? (B(e, d, g, !0), le(e, M(e, !1, i)), d = g = e.position) : e.position === e.lineStart && K(e) ? _(e, "unexpected end of the document within a single quoted scalar") : (e.position++, j(f) || (g = e.position));
    _(e, "unexpected end of the stream within a single quoted scalar");
  }
  function Ce(e, i) {
    let d, g, f, n = e.input.charCodeAt(e.position);
    if (n !== 34)
      return !1;
    for (e.kind = "scalar", e.result = "", e.position++, d = g = e.position; (n = e.input.charCodeAt(e.position)) !== 0; ) {
      if (n === 34)
        return B(e, d, e.position, !0), e.position++, !0;
      if (n === 92) {
        if (B(e, d, e.position, !0), n = e.input.charCodeAt(++e.position), Y(n))
          M(e, !1, i);
        else if (n < 256 && Se[n])
          e.result += ue[n], e.position++;
        else if ((f = Ne(n)) > 0) {
          let o = f, u = 0;
          for (; o > 0; o--)
            n = e.input.charCodeAt(++e.position), (f = Le(n)) >= 0 ? u = (u << 4) + f : _(e, "expected hexadecimal character");
          e.result += Re(u), e.position++;
        } else
          _(e, "unknown escape sequence");
        d = g = e.position;
      } else Y(n) ? (B(e, d, g, !0), le(e, M(e, !1, i)), d = g = e.position) : e.position === e.lineStart && K(e) ? _(e, "unexpected end of the document within a double quoted scalar") : (e.position++, j(n) || (g = e.position));
    }
    _(e, "unexpected end of the stream within a double quoted scalar");
  }
  function ke(e, i) {
    let d = !0, g, f, n;
    const o = e.tag;
    let u;
    const y = e.anchor;
    let A, w, a, C;
    const E = /* @__PURE__ */ Object.create(null);
    let I, v, O, L = e.input.charCodeAt(e.position);
    if (L === 91)
      A = 93, C = !1, u = [];
    else if (L === 123)
      A = 125, C = !0, u = {};
    else
      return !1;
    for (e.anchor !== null && W(e, e.anchor, u), L = e.input.charCodeAt(++e.position); L !== 0; ) {
      if (M(e, !0, i), L = e.input.charCodeAt(e.position), L === A)
        return e.position++, e.tag = o, e.anchor = y, e.kind = C ? "mapping" : "sequence", e.result = u, !0;
      if (d ? L === 44 && _(e, "expected the node content, but found ','") : _(e, "missed comma between flow collection entries"), v = I = O = null, w = a = !1, L === 63) {
        const z = e.input.charCodeAt(e.position + 1);
        q(z) && (w = a = !0, e.position++, M(e, !0, i));
      }
      g = e.line, f = e.lineStart, n = e.position, Z(e, i, S, !1, !0), v = e.tag, I = e.result, M(e, !0, i), L = e.input.charCodeAt(e.position), (a || e.line === g) && L === 58 && (w = !0, L = e.input.charCodeAt(++e.position), M(e, !0, i), Z(e, i, S, !1, !0), O = e.result), C ? G(e, u, E, v, I, O, g, f, n) : w ? u.push(G(e, null, E, v, I, O, g, f, n)) : u.push(I), M(e, !0, i), L = e.input.charCodeAt(e.position), L === 44 ? (d = !0, L = e.input.charCodeAt(++e.position)) : d = !1;
    }
    _(e, "unexpected end of the stream within a flow collection");
  }
  function X(e, i) {
    let d, g = c, f = !1, n = !1, o = i, u = 0, y = !1, A, w = e.input.charCodeAt(e.position);
    if (w === 124)
      d = !1;
    else if (w === 62)
      d = !0;
    else
      return !1;
    for (e.kind = "scalar", e.result = ""; w !== 0; )
      if (w = e.input.charCodeAt(++e.position), w === 43 || w === 45)
        c === g ? g = w === 43 ? T : l : _(e, "repeat of a chomping mode identifier");
      else if ((A = Ae(w)) >= 0)
        A === 0 ? _(e, "bad explicit indentation width of a block scalar; it cannot be less than one") : n ? _(e, "repeat of an indentation width identifier") : (o = i + A - 1, n = !0);
      else
        break;
    if (j(w)) {
      do
        w = e.input.charCodeAt(++e.position);
      while (j(w));
      if (w === 35)
        do
          w = e.input.charCodeAt(++e.position);
        while (!Y(w) && w !== 0);
    }
    for (; w !== 0; ) {
      for (ae(e), e.lineIndent = 0, w = e.input.charCodeAt(e.position); (!n || e.lineIndent < o) && w === 32; )
        e.lineIndent++, w = e.input.charCodeAt(++e.position);
      if (!n && e.lineIndent > o && (o = e.lineIndent), Y(w)) {
        u++;
        continue;
      }
      if (!n && o === 0 && _(e, "missing indentation for block scalar"), e.lineIndent < o) {
        g === T ? e.result += r.repeat(`
`, f ? 1 + u : u) : g === c && f && (e.result += `
`);
        break;
      }
      d ? j(w) ? (y = !0, e.result += r.repeat(`
`, f ? 1 + u : u)) : y ? (y = !1, e.result += r.repeat(`
`, u + 1)) : u === 0 ? f && (e.result += " ") : e.result += r.repeat(`
`, u) : e.result += r.repeat(`
`, f ? 1 + u : u), f = !0, n = !0, u = 0;
      const a = e.position;
      for (; !Y(w) && w !== 0; )
        w = e.input.charCodeAt(++e.position);
      B(e, a, e.position, !1);
    }
    return !0;
  }
  function Ee(e, i) {
    const d = e.tag, g = e.anchor, f = [];
    let n = !1;
    if (e.firstTabInLine !== -1) return !1;
    e.anchor !== null && W(e, e.anchor, f);
    let o = e.input.charCodeAt(e.position);
    for (; o !== 0 && (e.firstTabInLine !== -1 && (e.position = e.firstTabInLine, _(e, "tab characters must not be used in indentation")), o === 45); ) {
      const u = e.input.charCodeAt(e.position + 1);
      if (!q(u))
        break;
      if (n = !0, e.position++, M(e, !0, -1) && e.lineIndent <= i) {
        f.push(null), o = e.input.charCodeAt(e.position);
        continue;
      }
      const y = e.line;
      if (Z(e, i, s, !1, !0), f.push(e.result), M(e, !0, -1), o = e.input.charCodeAt(e.position), (e.line === y || e.lineIndent > i) && o !== 0)
        _(e, "bad indentation of a sequence entry");
      else if (e.lineIndent < i)
        break;
    }
    return n ? (e.tag = d, e.anchor = g, e.kind = "sequence", e.result = f, !0) : !1;
  }
  function _e(e, i, d) {
    let g, f, n, o;
    const u = e.tag, y = e.anchor, A = {}, w = /* @__PURE__ */ Object.create(null);
    let a = null, C = null, E = null, I = !1, v = !1;
    if (e.firstTabInLine !== -1) return !1;
    e.anchor !== null && W(e, e.anchor, A);
    let O = e.input.charCodeAt(e.position);
    for (; O !== 0; ) {
      !I && e.firstTabInLine !== -1 && (e.position = e.firstTabInLine, _(e, "tab characters must not be used in indentation"));
      const L = e.input.charCodeAt(e.position + 1), z = e.line;
      if ((O === 63 || O === 58) && q(L))
        O === 63 ? (I && (G(e, A, w, a, C, null, f, n, o), a = C = E = null), v = !0, I = !0, g = !0) : I ? (I = !1, g = !0) : _(e, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), e.position += 1, O = L;
      else {
        if (f = e.line, n = e.lineStart, o = e.position, !Z(e, d, h, !1, !0))
          break;
        if (e.line === z) {
          for (O = e.input.charCodeAt(e.position); j(O); )
            O = e.input.charCodeAt(++e.position);
          if (O === 58)
            O = e.input.charCodeAt(++e.position), q(O) || _(e, "a whitespace character is expected after the key-value separator within a block mapping"), I && (G(e, A, w, a, C, null, f, n, o), a = C = E = null), v = !0, I = !1, g = !1, a = e.tag, C = e.result;
          else if (v)
            _(e, "can not read an implicit mapping pair; a colon is missed");
          else
            return e.tag = u, e.anchor = y, !0;
        } else if (v)
          _(e, "can not read a block mapping entry; a multiline key may not be an implicit key");
        else
          return e.tag = u, e.anchor = y, !0;
      }
      if ((e.line === z || e.lineIndent > i) && (I && (f = e.line, n = e.lineStart, o = e.position), Z(e, i, b, !0, g) && (I ? C = e.result : E = e.result), I || (G(e, A, w, a, C, E, f, n, o), a = C = E = null), M(e, !0, -1), O = e.input.charCodeAt(e.position)), (e.line === z || e.lineIndent > i) && O !== 0)
        _(e, "bad indentation of a mapping entry");
      else if (e.lineIndent < i)
        break;
    }
    return I && G(e, A, w, a, C, null, f, n, o), v && (e.tag = u, e.anchor = y, e.kind = "mapping", e.result = A), v;
  }
  function Ie(e) {
    let i = !1, d = !1, g, f, n = e.input.charCodeAt(e.position);
    if (n !== 33) return !1;
    e.tag !== null && _(e, "duplication of a tag property"), n = e.input.charCodeAt(++e.position), n === 60 ? (i = !0, n = e.input.charCodeAt(++e.position)) : n === 33 ? (d = !0, g = "!!", n = e.input.charCodeAt(++e.position)) : g = "!";
    let o = e.position;
    if (i) {
      do
        n = e.input.charCodeAt(++e.position);
      while (n !== 0 && n !== 62);
      e.position < e.length ? (f = e.input.slice(o, e.position), n = e.input.charCodeAt(++e.position)) : _(e, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; n !== 0 && !q(n); )
        n === 33 && (d ? _(e, "tag suffix cannot contain exclamation marks") : (g = e.input.slice(o - 1, e.position + 1), R.test(g) || _(e, "named tag handle cannot contain such characters"), d = !0, o = e.position + 1)), n = e.input.charCodeAt(++e.position);
      f = e.input.slice(o, e.position), U.test(f) && _(e, "tag suffix cannot contain flow indicator characters");
    }
    f && !H.test(f) && _(e, "tag name cannot contain such characters: " + f);
    try {
      f = decodeURIComponent(f);
    } catch {
      _(e, "tag name is malformed: " + f);
    }
    return i ? e.tag = f : p.call(e.tagMap, g) ? e.tag = e.tagMap[g] + f : g === "!" ? e.tag = "!" + f : g === "!!" ? e.tag = "tag:yaml.org,2002:" + f : _(e, 'undeclared tag handle "' + g + '"'), !0;
  }
  function xe(e) {
    let i = e.input.charCodeAt(e.position);
    if (i !== 38) return !1;
    e.anchor !== null && _(e, "duplication of an anchor property"), i = e.input.charCodeAt(++e.position);
    const d = e.position;
    for (; i !== 0 && !q(i) && !Q(i); )
      i = e.input.charCodeAt(++e.position);
    return e.position === d && _(e, "name of an anchor node must contain at least one character"), e.anchor = e.input.slice(d, e.position), !0;
  }
  function qe(e) {
    let i = e.input.charCodeAt(e.position);
    if (i !== 42) return !1;
    i = e.input.charCodeAt(++e.position);
    const d = e.position;
    for (; i !== 0 && !q(i) && !Q(i); )
      i = e.input.charCodeAt(++e.position);
    e.position === d && _(e, "name of an alias node must contain at least one character");
    const g = e.input.slice(d, e.position);
    return p.call(e.anchorMap, g) || _(e, 'unidentified alias "' + g + '"'), e.result = e.anchorMap[g], M(e, !0, -1), !0;
  }
  function ve(e, i, d, g) {
    const f = fe(e);
    return Me(e), oe(e, i), e.tag = null, e.anchor = null, e.kind = null, e.result = null, _e(e, d, g) && e.kind === "mapping" ? (ie(e), !0) : (Fe(e), oe(e, f), !1);
  }
  function Z(e, i, d, g, f) {
    let n, o, u = 1, y = !1, A = !1, w = null, a, C, E;
    e.depth >= e.maxDepth && _(e, "nesting exceeded maxDepth (" + e.maxDepth + ")"), e.depth += 1, e.listener !== null && e.listener("open", e), e.tag = null, e.anchor = null, e.kind = null, e.result = null;
    const I = n = o = b === d || s === d;
    if (g && M(e, !0, -1) && (y = !0, e.lineIndent > i ? u = 1 : e.lineIndent === i ? u = 0 : e.lineIndent < i && (u = -1)), u === 1)
      for (; ; ) {
        const v = e.input.charCodeAt(e.position), O = fe(e);
        if (y && (v === 33 && e.tag !== null || v === 38 && e.anchor !== null) || !Ie(e) && !xe(e))
          break;
        w === null && (w = O), M(e, !0, -1) ? (y = !0, o = I, e.lineIndent > i ? u = 1 : e.lineIndent === i ? u = 0 : e.lineIndent < i && (u = -1)) : o = !1;
      }
    if (o && (o = y || f), u === 1 || b === d)
      if (S === d || h === d ? C = i : C = i + 1, E = e.position - e.lineStart, u === 1)
        if (o && (Ee(e, E) || _e(e, E, C)) || ke(e, C))
          A = !0;
        else {
          const v = e.input.charCodeAt(e.position);
          w !== null && I && !o && v !== 124 && v !== 62 && ve(
            e,
            w,
            w.position - w.lineStart,
            C
          ) || n && X(e, C) || pe(e, C) || Ce(e, C) ? A = !0 : qe(e) ? (A = !0, (e.tag !== null || e.anchor !== null) && _(e, "alias node should not have any properties")) : Te(e, C, S === d) && (A = !0, e.tag === null && (e.tag = "?")), e.anchor !== null && W(e, e.anchor, e.result);
        }
      else u === 0 && (A = o && Ee(e, E));
    if (e.tag === null)
      e.anchor !== null && W(e, e.anchor, e.result);
    else if (e.tag === "?") {
      e.result !== null && e.kind !== "scalar" && _(e, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + e.kind + '"');
      for (let v = 0, O = e.implicitTypes.length; v < O; v += 1)
        if (a = e.implicitTypes[v], a.resolve(e.result)) {
          e.result = a.construct(e.result), e.tag = a.tag, e.anchor !== null && W(e, e.anchor, e.result);
          break;
        }
    } else if (e.tag !== "!") {
      if (p.call(e.typeMap[e.kind || "fallback"], e.tag))
        a = e.typeMap[e.kind || "fallback"][e.tag];
      else {
        a = null;
        const v = e.typeMap.multi[e.kind || "fallback"];
        for (let O = 0, L = v.length; O < L; O += 1)
          if (e.tag.slice(0, v[O].tag.length) === v[O].tag) {
            a = v[O];
            break;
          }
      }
      a || _(e, "unknown tag !<" + e.tag + ">"), e.result !== null && a.kind !== e.kind && _(e, "unacceptable node kind for !<" + e.tag + '> tag; it should be "' + a.kind + '", not "' + e.kind + '"'), a.resolve(e.result, e.tag) ? (e.result = a.construct(e.result, e.tag), e.anchor !== null && W(e, e.anchor, e.result)) : _(e, "cannot resolve a node with !<" + e.tag + "> explicit tag");
    }
    return e.listener !== null && e.listener("close", e), e.depth -= 1, e.tag !== null || e.anchor !== null || A;
  }
  function Pe(e) {
    const i = e.position;
    let d = !1, g;
    for (e.version = null, e.checkLineBreaks = e.legacy, e.tagMap = /* @__PURE__ */ Object.create(null), e.anchorMap = /* @__PURE__ */ Object.create(null); (g = e.input.charCodeAt(e.position)) !== 0 && (M(e, !0, -1), g = e.input.charCodeAt(e.position), !(e.lineIndent > 0 || g !== 37)); ) {
      d = !0, g = e.input.charCodeAt(++e.position);
      let f = e.position;
      for (; g !== 0 && !q(g); )
        g = e.input.charCodeAt(++e.position);
      const n = e.input.slice(f, e.position), o = [];
      for (n.length < 1 && _(e, "directive name must not be less than one character in length"); g !== 0; ) {
        for (; j(g); )
          g = e.input.charCodeAt(++e.position);
        if (g === 35) {
          do
            g = e.input.charCodeAt(++e.position);
          while (g !== 0 && !Y(g));
          break;
        }
        if (Y(g)) break;
        for (f = e.position; g !== 0 && !q(g); )
          g = e.input.charCodeAt(++e.position);
        o.push(e.input.slice(f, e.position));
      }
      g !== 0 && ae(e), p.call(be, n) ? be[n](e, n, o) : re(e, 'unknown document directive "' + n + '"');
    }
    if (M(e, !0, -1), e.lineIndent === 0 && e.input.charCodeAt(e.position) === 45 && e.input.charCodeAt(e.position + 1) === 45 && e.input.charCodeAt(e.position + 2) === 45 ? (e.position += 3, M(e, !0, -1)) : d && _(e, "directives end mark is expected"), Z(e, e.lineIndent - 1, b, !1, !0), M(e, !0, -1), e.checkLineBreaks && N.test(e.input.slice(i, e.position)) && re(e, "non-ASCII line breaks are interpreted as content"), e.documents.push(e.result), e.position === e.lineStart && K(e)) {
      e.input.charCodeAt(e.position) === 46 && (e.position += 3, M(e, !0, -1));
      return;
    }
    e.position < e.length - 1 && _(e, "end of the stream or a document separator is expected");
  }
  function de(e, i) {
    e = String(e), i = i || {}, e.length !== 0 && (e.charCodeAt(e.length - 1) !== 10 && e.charCodeAt(e.length - 1) !== 13 && (e += `
`), e.charCodeAt(0) === 65279 && (e = e.slice(1)));
    const d = new F(e, i), g = e.indexOf("\0");
    for (g !== -1 && (d.position = g, _(d, "null byte is not allowed in input")), d.input += "\0"; d.input.charCodeAt(d.position) === 32; )
      d.lineIndent += 1, d.position += 1;
    for (; d.position < d.length - 1; )
      Pe(d);
    return d.documents;
  }
  function De(e, i, d) {
    i !== null && typeof i == "object" && typeof d > "u" && (d = i, i = null);
    const g = de(e, d);
    if (typeof i != "function")
      return g;
    for (let f = 0, n = g.length; f < n; f += 1)
      i(g[f]);
  }
  function Ye(e, i) {
    const d = de(e, i);
    if (d.length !== 0) {
      if (d.length === 1)
        return d[0];
      throw new t("expected a single document in the stream, but found more");
    }
  }
  return Oe.loadAll = De, Oe.load = Ye, Oe;
}
var un = {}, qn;
function yi() {
  if (qn) return un;
  qn = 1;
  const r = ge(), t = ye(), m = an(), k = Object.prototype.toString, p = Object.prototype.hasOwnProperty, S = 65279, h = 9, s = 10, b = 13, c = 32, l = 33, T = 34, x = 35, N = 37, U = 38, R = 39, H = 42, ne = 44, Y = 45, j = 58, q = 61, Q = 62, Le = 63, Ne = 64, Ae = 91, te = 93, Re = 96, ce = 123, Se = 124, ue = 125, F = {};
  F[0] = "\\0", F[7] = "\\a", F[8] = "\\b", F[9] = "\\t", F[10] = "\\n", F[11] = "\\v", F[12] = "\\f", F[13] = "\\r", F[27] = "\\e", F[34] = '\\"', F[92] = "\\\\", F[133] = "\\N", F[160] = "\\_", F[8232] = "\\L", F[8233] = "\\P";
  const we = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ], _ = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
  function re(n, o) {
    if (o === null) return {};
    const u = {}, y = Object.keys(o);
    for (let A = 0, w = y.length; A < w; A += 1) {
      let a = y[A], C = String(o[a]);
      a.slice(0, 2) === "!!" && (a = "tag:yaml.org,2002:" + a.slice(2));
      const E = n.compiledTypeMap.fallback[a];
      E && p.call(E.styleAliases, C) && (C = E.styleAliases[C]), u[a] = C;
    }
    return u;
  }
  function W(n) {
    let o, u;
    const y = n.toString(16).toUpperCase();
    if (n <= 255)
      o = "x", u = 2;
    else if (n <= 65535)
      o = "u", u = 4;
    else if (n <= 4294967295)
      o = "U", u = 8;
    else
      throw new t("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + o + r.repeat("0", u - y.length) + y;
  }
  const Me = 1, ie = 2;
  function Fe(n) {
    this.schema = n.schema || m, this.indent = Math.max(1, n.indent || 2), this.noArrayIndent = n.noArrayIndent || !1, this.skipInvalid = n.skipInvalid || !1, this.flowLevel = r.isNothing(n.flowLevel) ? -1 : n.flowLevel, this.styleMap = re(this.schema, n.styles || null), this.sortKeys = n.sortKeys || !1, this.lineWidth = n.lineWidth || 80, this.noRefs = n.noRefs || !1, this.noCompatMode = n.noCompatMode || !1, this.condenseFlow = n.condenseFlow || !1, this.quotingType = n.quotingType === '"' ? ie : Me, this.forceQuotes = n.forceQuotes || !1, this.replacer = typeof n.replacer == "function" ? n.replacer : null, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function fe(n, o) {
    const u = r.repeat(" ", o);
    let y = 0, A = "";
    const w = n.length;
    for (; y < w; ) {
      let a;
      const C = n.indexOf(`
`, y);
      C === -1 ? (a = n.slice(y), y = w) : (a = n.slice(y, C + 1), y = C + 1), a.length && a !== `
` && (A += u), A += a;
    }
    return A;
  }
  function oe(n, o) {
    return `
` + r.repeat(" ", n.indent * o);
  }
  function be(n, o) {
    for (let u = 0, y = n.implicitTypes.length; u < y; u += 1)
      if (n.implicitTypes[u].resolve(o))
        return !0;
    return !1;
  }
  function B(n) {
    return n === c || n === h;
  }
  function J(n) {
    return n >= 32 && n <= 126 || n >= 161 && n <= 55295 && n !== 8232 && n !== 8233 || n >= 57344 && n <= 65533 && n !== S || n >= 65536 && n <= 1114111;
  }
  function se(n) {
    return J(n) && n !== S && // - b-char
    n !== b && n !== s;
  }
  function G(n, o, u) {
    const y = se(n), A = y && !B(n);
    return (
      // ns-plain-safe
      (u ? y : y && // - c-flow-indicator
      n !== ne && n !== Ae && n !== te && n !== ce && n !== ue) && // ns-plain-char
      n !== x && // false on '#'
      !(o === j && !A) || // false on ': '
      se(o) && !B(o) && n === x || // change to true on '[^ ]#'
      o === j && A
    );
  }
  function ae(n) {
    return J(n) && n !== S && !B(n) && // - s-white
    // - (c-indicator ::=
    // “-” | “?” | “:” | “,” | “[” | “]” | “{” | “}”
    n !== Y && n !== Le && n !== j && n !== ne && n !== Ae && n !== te && n !== ce && n !== ue && // | “#” | “&” | “*” | “!” | “|” | “=” | “>” | “'” | “"”
    n !== x && n !== U && n !== H && n !== l && n !== Se && n !== q && n !== Q && n !== R && n !== T && // | “%” | “@” | “`”)
    n !== N && n !== Ne && n !== Re;
  }
  function M(n) {
    return !B(n) && n !== j;
  }
  function K(n, o) {
    const u = n.charCodeAt(o);
    let y;
    return u >= 55296 && u <= 56319 && o + 1 < n.length && (y = n.charCodeAt(o + 1), y >= 56320 && y <= 57343) ? (u - 55296) * 1024 + y - 56320 + 65536 : u;
  }
  function le(n) {
    return /^\n* /.test(n);
  }
  const Te = 1, pe = 2, Ce = 3, ke = 4, X = 5;
  function Ee(n, o, u, y, A, w, a, C) {
    let E, I = 0, v = null, O = !1, L = !1;
    const z = y !== -1;
    let he = -1, me = ae(K(n, 0)) && M(K(n, n.length - 1));
    if (o || a)
      for (E = 0; E < n.length; I >= 65536 ? E += 2 : E++) {
        if (I = K(n, E), !J(I))
          return X;
        me = me && G(I, v, C), v = I;
      }
    else {
      for (E = 0; E < n.length; I >= 65536 ? E += 2 : E++) {
        if (I = K(n, E), I === s)
          O = !0, z && (L = L || // Foldable line = too long, and not more-indented.
          E - he - 1 > y && n[he + 1] !== " ", he = E);
        else if (!J(I))
          return X;
        me = me && G(I, v, C), v = I;
      }
      L = L || z && E - he - 1 > y && n[he + 1] !== " ";
    }
    return !O && !L ? me && !a && !A(n) ? Te : w === ie ? X : pe : u > 9 && le(n) ? X : a ? w === ie ? X : pe : L ? ke : Ce;
  }
  function _e(n, o, u, y, A) {
    n.dump = (function() {
      if (o.length === 0)
        return n.quotingType === ie ? '""' : "''";
      if (!n.noCompatMode && (we.indexOf(o) !== -1 || _.test(o)))
        return n.quotingType === ie ? '"' + o + '"' : "'" + o + "'";
      const w = n.indent * Math.max(1, u), a = n.lineWidth === -1 ? -1 : Math.max(Math.min(n.lineWidth, 40), n.lineWidth - w), C = y || // No block styles in flow mode.
      n.flowLevel > -1 && u >= n.flowLevel;
      function E(I) {
        return be(n, I);
      }
      switch (Ee(
        o,
        C,
        n.indent,
        a,
        E,
        n.quotingType,
        n.forceQuotes && !y,
        A
      )) {
        case Te:
          return o;
        case pe:
          return "'" + o.replace(/'/g, "''") + "'";
        case Ce:
          return "|" + Ie(o, n.indent) + xe(fe(o, w));
        case ke:
          return ">" + Ie(o, n.indent) + xe(fe(qe(o, a), w));
        case X:
          return '"' + Z(o) + '"';
        default:
          throw new t("impossible error: invalid scalar style");
      }
    })();
  }
  function Ie(n, o) {
    const u = le(n) ? String(o) : "", y = n[n.length - 1] === `
`, w = y && (n[n.length - 2] === `
` || n === `
`) ? "+" : y ? "" : "-";
    return u + w + `
`;
  }
  function xe(n) {
    return n[n.length - 1] === `
` ? n.slice(0, -1) : n;
  }
  function qe(n, o) {
    const u = /(\n+)([^\n]*)/g;
    let y = (function() {
      let C = n.indexOf(`
`);
      return C = C !== -1 ? C : n.length, u.lastIndex = C, ve(n.slice(0, C), o);
    })(), A = n[0] === `
` || n[0] === " ", w, a;
    for (; a = u.exec(n); ) {
      const C = a[1], E = a[2];
      w = E[0] === " ", y += C + (!A && !w && E !== "" ? `
` : "") + ve(E, o), A = w;
    }
    return y;
  }
  function ve(n, o) {
    if (n === "" || n[0] === " ") return n;
    const u = / [^ ]/g;
    let y, A = 0, w, a = 0, C = 0, E = "";
    for (; y = u.exec(n); )
      C = y.index, C - A > o && (w = a > A ? a : C, E += `
` + n.slice(A, w), A = w + 1), a = C;
    return E += `
`, n.length - A > o && a > A ? E += n.slice(A, a) + `
` + n.slice(a + 1) : E += n.slice(A), E.slice(1);
  }
  function Z(n) {
    let o = "", u = 0;
    for (let y = 0; y < n.length; u >= 65536 ? y += 2 : y++) {
      u = K(n, y);
      const A = F[u];
      !A && J(u) ? (o += n[y], u >= 65536 && (o += n[y + 1])) : o += A || W(u);
    }
    return o;
  }
  function Pe(n, o, u) {
    let y = "";
    const A = n.tag;
    for (let w = 0, a = u.length; w < a; w += 1) {
      let C = u[w];
      n.replacer && (C = n.replacer.call(u, String(w), C)), (i(n, o, C, !1, !1) || typeof C > "u" && i(n, o, null, !1, !1)) && (y !== "" && (y += "," + (n.condenseFlow ? "" : " ")), y += n.dump);
    }
    n.tag = A, n.dump = "[" + y + "]";
  }
  function de(n, o, u, y) {
    let A = "";
    const w = n.tag;
    for (let a = 0, C = u.length; a < C; a += 1) {
      let E = u[a];
      n.replacer && (E = n.replacer.call(u, String(a), E)), (i(n, o + 1, E, !0, !0, !1, !0) || typeof E > "u" && i(n, o + 1, null, !0, !0, !1, !0)) && ((!y || A !== "") && (A += oe(n, o)), n.dump && s === n.dump.charCodeAt(0) ? A += "-" : A += "- ", A += n.dump);
    }
    n.tag = w, n.dump = A || "[]";
  }
  function De(n, o, u) {
    let y = "";
    const A = n.tag, w = Object.keys(u);
    for (let a = 0, C = w.length; a < C; a += 1) {
      let E = "";
      y !== "" && (E += ", "), n.condenseFlow && (E += '"');
      const I = w[a];
      let v = u[I];
      n.replacer && (v = n.replacer.call(u, I, v)), i(n, o, I, !1, !1) && (n.dump.length > 1024 && (E += "? "), E += n.dump + (n.condenseFlow ? '"' : "") + ":" + (n.condenseFlow ? "" : " "), i(n, o, v, !1, !1) && (E += n.dump, y += E));
    }
    n.tag = A, n.dump = "{" + y + "}";
  }
  function Ye(n, o, u, y) {
    let A = "";
    const w = n.tag, a = Object.keys(u);
    if (n.sortKeys === !0)
      a.sort();
    else if (typeof n.sortKeys == "function")
      a.sort(n.sortKeys);
    else if (n.sortKeys)
      throw new t("sortKeys must be a boolean or a function");
    for (let C = 0, E = a.length; C < E; C += 1) {
      let I = "";
      (!y || A !== "") && (I += oe(n, o));
      const v = a[C];
      let O = u[v];
      if (n.replacer && (O = n.replacer.call(u, v, O)), !i(n, o + 1, v, !0, !0, !0))
        continue;
      const L = n.tag !== null && n.tag !== "?" || n.dump && n.dump.length > 1024;
      L && (n.dump && s === n.dump.charCodeAt(0) ? I += "?" : I += "? "), I += n.dump, L && (I += oe(n, o)), i(n, o + 1, O, !0, L) && (n.dump && s === n.dump.charCodeAt(0) ? I += ":" : I += ": ", I += n.dump, A += I);
    }
    n.tag = w, n.dump = A || "{}";
  }
  function e(n, o, u) {
    const y = u ? n.explicitTypes : n.implicitTypes;
    for (let A = 0, w = y.length; A < w; A += 1) {
      const a = y[A];
      if ((a.instanceOf || a.predicate) && (!a.instanceOf || typeof o == "object" && o instanceof a.instanceOf) && (!a.predicate || a.predicate(o))) {
        if (u ? a.multi && a.representName ? n.tag = a.representName(o) : n.tag = a.tag : n.tag = "?", a.represent) {
          const C = n.styleMap[a.tag] || a.defaultStyle;
          let E;
          if (k.call(a.represent) === "[object Function]")
            E = a.represent(o, C);
          else if (p.call(a.represent, C))
            E = a.represent[C](o, C);
          else
            throw new t("!<" + a.tag + '> tag resolver accepts not "' + C + '" style');
          n.dump = E;
        }
        return !0;
      }
    }
    return !1;
  }
  function i(n, o, u, y, A, w, a) {
    n.tag = null, n.dump = u, e(n, u, !1) || e(n, u, !0);
    const C = k.call(n.dump), E = y;
    y && (y = n.flowLevel < 0 || n.flowLevel > o);
    const I = C === "[object Object]" || C === "[object Array]";
    let v, O;
    if (I && (v = n.duplicates.indexOf(u), O = v !== -1), (n.tag !== null && n.tag !== "?" || O || n.indent !== 2 && o > 0) && (A = !1), O && n.usedDuplicates[v])
      n.dump = "*ref_" + v;
    else {
      if (I && O && !n.usedDuplicates[v] && (n.usedDuplicates[v] = !0), C === "[object Object]")
        y && Object.keys(n.dump).length !== 0 ? (Ye(n, o, n.dump, A), O && (n.dump = "&ref_" + v + n.dump)) : (De(n, o, n.dump), O && (n.dump = "&ref_" + v + " " + n.dump));
      else if (C === "[object Array]")
        y && n.dump.length !== 0 ? (n.noArrayIndent && !a && o > 0 ? de(n, o - 1, n.dump, A) : de(n, o, n.dump, A), O && (n.dump = "&ref_" + v + n.dump)) : (Pe(n, o, n.dump), O && (n.dump = "&ref_" + v + " " + n.dump));
      else if (C === "[object String]")
        n.tag !== "?" && _e(n, n.dump, o, w, E);
      else {
        if (C === "[object Undefined]")
          return !1;
        if (n.skipInvalid) return !1;
        throw new t("unacceptable kind of an object to dump " + C);
      }
      if (n.tag !== null && n.tag !== "?") {
        let L = encodeURI(
          n.tag[0] === "!" ? n.tag.slice(1) : n.tag
        ).replace(/!/g, "%21");
        n.tag[0] === "!" ? L = "!" + L : L.slice(0, 18) === "tag:yaml.org,2002:" ? L = "!!" + L.slice(18) : L = "!<" + L + ">", n.dump = L + " " + n.dump;
      }
    }
    return !0;
  }
  function d(n, o) {
    const u = [], y = [];
    g(n, u, y);
    const A = y.length;
    for (let w = 0; w < A; w += 1)
      o.duplicates.push(u[y[w]]);
    o.usedDuplicates = new Array(A);
  }
  function g(n, o, u) {
    if (n !== null && typeof n == "object") {
      const y = o.indexOf(n);
      if (y !== -1)
        u.indexOf(y) === -1 && u.push(y);
      else if (o.push(n), Array.isArray(n))
        for (let A = 0, w = n.length; A < w; A += 1)
          g(n[A], o, u);
      else {
        const A = Object.keys(n);
        for (let w = 0, a = A.length; w < a; w += 1)
          g(n[A[w]], o, u);
      }
    }
  }
  function f(n, o) {
    o = o || {};
    const u = new Fe(o);
    u.noRefs || d(n, u);
    let y = n;
    return u.replacer && (y = u.replacer.call({ "": y }, "", y)), i(u, 0, y, !0, !0) ? u.dump + `
` : "";
  }
  return un.dump = f, un;
}
var Pn;
function Ai() {
  if (Pn) return P;
  Pn = 1;
  const r = gi(), t = yi();
  function m(k, p) {
    return function() {
      throw new Error("Function yaml." + k + " is removed in js-yaml 4. Use yaml." + p + " instead, which is now safe by default.");
    };
  }
  return P.Type = D(), P.Schema = Bn(), P.FAILSAFE_SCHEMA = $n(), P.JSON_SCHEMA = Jn(), P.CORE_SCHEMA = Xn(), P.DEFAULT_SCHEMA = an(), P.load = r.load, P.loadAll = r.loadAll, P.dump = t.dump, P.YAMLException = ye(), P.types = {
    binary: ei(),
    float: Qn(),
    map: Kn(),
    null: Wn(),
    pairs: ii(),
    set: ri(),
    timestamp: Zn(),
    bool: Gn(),
    int: Vn(),
    merge: zn(),
    omap: ni(),
    seq: Un(),
    str: Hn()
  }, P.safeLoad = m("safeLoad", "load"), P.safeLoadAll = m("safeLoadAll", "loadAll"), P.safeDump = m("safeDump", "dump"), P;
}
var Si = Ai();
const wi = /* @__PURE__ */ hi(Si), {
  Type: qi,
  Schema: Pi,
  FAILSAFE_SCHEMA: Di,
  JSON_SCHEMA: Yi,
  CORE_SCHEMA: ji,
  DEFAULT_SCHEMA: Bi,
  load: Hi,
  loadAll: Ui,
  dump: Ki,
  YAMLException: $i,
  types: Wi,
  safeLoad: Gi,
  safeLoadAll: Vi,
  safeDump: Qi
} = wi, oi = ti(null);
function Ji({
  resolver: r,
  children: t
}) {
  return /* @__PURE__ */ li(oi.Provider, { value: r ?? null, children: t });
}
function Xi() {
  return ci(oi);
}
function Zi(r, t) {
  const m = () => r.resolve(t);
  return fn(r.subscribe, m, m);
}
function zi(r, t) {
  const m = () => r.statementsAbout(t);
  return fn(r.subscribe, m, m);
}
function er(r, t) {
  const m = () => r.backlinks(t);
  return fn(r.subscribe, m, m);
}
const bi = /* @__PURE__ */ new Set(["accepted", "approved"]), Ti = /* @__PURE__ */ new Set(["proposed", "in-review", "changes-requested", "disputed"]), Ci = /* @__PURE__ */ new Set(["superseded", "abandoned", "deferred", "withdrawn"]), ki = /* @__PURE__ */ new Set(["open", "draft"]);
function Ei(r, t) {
  if (!t) return "open";
  const { value: m, category: k } = t;
  return bi.has(m) || k === "done" ? "settled" : m === "rejected" ? "negative" : Ci.has(m) ? "parked" : Ti.has(m) ? "waiting" : ki.has(m) ? "open" : k === "started" ? "active" : k === "cancelled" || k === "backlog" ? "parked" : "open";
}
const Dn = {
  claim: /* @__PURE__ */ new Set(["asserted"]),
  finding: /* @__PURE__ */ new Set(["active"]),
  entity: /* @__PURE__ */ new Set(["active"])
};
function nr(r, t) {
  return t ? Dn[r]?.has(t) ?? !1 : !!Dn[r];
}
function ir(r, t) {
  return t || r === "settled" ? "solid" : r === "parked" || r === "negative" ? "bare" : "dashed";
}
const _i = {
  proposed: "Open for discussion again",
  accepted: "Settled. You are recorded as deciding.",
  superseded: "Replaced by a later decision",
  open: "Nobody is working on it yet",
  investigating: "Someone is working it out",
  reopened: "The answer no longer holds",
  blocked: "Waiting on something else",
  abandoned: "Stopped; kept for the record",
  draft: "Still being written",
  "in-review": "Waiting on reviewers",
  "changes-requested": "Back to the author",
  approved: "Reviewers agreed",
  building: "Being built",
  shipped: "Done and released"
}, Ii = {
  accepted: "accepted",
  rejected: "rejected",
  answered: "answered",
  deferred: "deferred",
  abandoned: "abandoned",
  superseded: "superseded",
  approved: "approved",
  shipped: "shipped",
  reopened: "reopened"
}, xi = {
  field: "whyNot",
  label: 'Why not? Shown on the page and under "What we decided not to do".',
  placeholder: "What rules it out",
  confirmLabel: "Reject"
}, vi = {
  field: "revisitWhen",
  label: "When should we revisit it?",
  placeholder: "After the beta, or a date",
  confirmLabel: "Defer"
}, Oi = {
  field: "supersededBy",
  label: "Replaced by which item? Enter its key.",
  placeholder: "SEC-57",
  confirmLabel: "Supersede"
};
function Li(r, t) {
  return Ii[r] ?? `moved this to ${t}`;
}
function Yn(r, t) {
  const m = {
    id: `status:${t.value}`,
    label: t.label,
    tone: Ei(r, t),
    toStatus: t.value,
    verb: Li(t.value, t.label)
  }, k = _i[t.value];
  return k && (m.description = k), (t.value === "accepted" || t.value === "rejected") && (m.recordsDecision = !0), t.value === "rejected" && (m.prompt = xi, m.description = "Asks why not"), t.value === "deferred" && (m.prompt = vi, m.description = "Asks when to revisit"), t.value === "superseded" && r === "wiki-decision" && (m.prompt = Oi, m.description = "Asks for the replacement"), m;
}
function rr(r) {
  const { type: t, status: m, statusOptions: k } = r, p = k.filter((b) => b.value !== m);
  if (t !== "question") return p.map((b) => Yn(t, b));
  const S = [], h = r.positionState === "proposed" && !!r.position?.trim();
  if (m !== "answered" && h && p.some((b) => b.value === "answered")) {
    const b = r.positionOwnerName ? `${r.positionOwnerName}'s` : "the proposed";
    S.push({
      id: "accept-position",
      label: `Answered: accept ${b} position`,
      description: `"${r.position.trim()}" You are recorded as deciding.`,
      tone: "settled",
      toStatus: "answered",
      extra: { positionState: "accepted" },
      recordsDecision: !0,
      verb: "answered"
    });
  }
  m !== "answered" && r.canOpenItem && S.push({
    id: "write-position",
    label: h ? "Write a different position..." : "Write a position...",
    description: "Opens the question",
    tone: "open",
    toStatus: null,
    opensItem: !0,
    verb: ""
  });
  const s = p.filter((b) => b.value !== "answered").map((b) => Yn(t, b));
  return S.length > 0 && s.length > 0 && (s[0] = { ...s[0], separatorBefore: !0 }), [...S, ...s];
}
function or(r, t) {
  if (r.toStatus === null) return {};
  const m = { status: r.toStatus, ...r.extra };
  r.recordsDecision && t.actor && (m.decidedBy = t.actor.email, m.decidedAt = t.today);
  const k = t.input?.trim() ?? "";
  return r.prompt && (m[r.prompt.field] = r.prompt.field === "supersededBy" ? { itemId: k } : k), m;
}
function lr(r) {
  return r.find((t) => t.category === "cancelled")?.value ?? null;
}
function tr(r) {
  if (!r || typeof r != "object") return null;
  const t = r;
  return typeof t.by != "string" || t.kind !== "create" && t.kind !== "status" || t.kind === "status" && typeof t.toStatus != "string" ? null : t;
}
function cr(r, t) {
  return r.find((m) => m.toStatus === t && !m.opensItem) ?? null;
}
function ur(r) {
  if (typeof r != "string") return null;
  const t = /^(\d{4})-(\d{2})-(\d{2})/.exec(r);
  if (!t) return null;
  const m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][Number(t[2]) - 1];
  return m ? `${m} ${Number(t[3])}` : null;
}
function fr(r, t) {
  return typeof t != "string" || t.trim() === "" ? null : r.personName?.(t) ?? t.split("@")[0];
}
function sr(r = /* @__PURE__ */ new Date()) {
  const t = (m) => String(m).padStart(2, "0");
  return `${r.getFullYear()}-${t(r.getMonth() + 1)}-${t(r.getDate())}`;
}
export {
  jn as C,
  oi as T,
  rr as a,
  Mi as b,
  fr as c,
  sr as d,
  Ji as e,
  Zi as f,
  Xi as g,
  zi as h,
  Ki as i,
  nr as j,
  ir as k,
  ur as l,
  lr as m,
  cr as n,
  Fi as p,
  tr as r,
  Ei as s,
  or as t,
  er as u,
  Li as v,
  wi as y
};
//# sourceMappingURL=trackerReferenceLifecycle-xEM9DpA6.js.map
